import { c as _c } from "react/compiler-runtime";
import { Badge } from "@/components/ui/badge";
import { NodeIconTile } from "@/components/ui/node-icon-tile";
import type { X402Endpoint } from "@/hooks/useX402Endpoints";
import { providerFaviconUrl } from "@/lib/x402/providerSlug";
import Link from "next/link";
import { NetworkChip } from "./NetworkChip";
interface Props {
  apex: string;
  providerSlug: string;
  endpoints: X402Endpoint[];
}
const MAX_VISIBLE_NETWORKS = 4;
export function ProviderCard(t0) {
  const $ = _c(56);
  const {
    apex,
    providerSlug,
    endpoints
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== apex || $[1] !== endpoints || $[2] !== providerSlug) {
    const totalCalls = endpoints.reduce(_temp, 0);
    let t9;
    if ($[12] !== endpoints) {
      t9 = Array.from(new Set(endpoints.map(_temp2)));
      $[12] = endpoints;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    const networks = t9;
    let t10;
    if ($[14] !== networks) {
      t10 = networks.slice(0, MAX_VISIBLE_NETWORKS);
      $[14] = networks;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    const visible = t10;
    const overflow = networks.length - visible.length;
    let t11;
    if ($[16] !== apex) {
      t11 = providerFaviconUrl(apex);
      $[16] = apex;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    const faviconUrl = t11;
    T0 = Link;
    t5 = `/integrations/x402/${providerSlug}`;
    t6 = "border-ds-border bg-ds-surface-card hover:border-ds-text-disabled dark:hover:border-ds-neutral-700 hover:shadow-ds-elev-2 group flex cursor-pointer flex-col gap-4 overflow-hidden rounded-xl border p-5 transition-all";
    const t12 = `x402-provider-${providerSlug}`;
    const t13 = `x402 provider ${apex}`;
    let t14;
    if ($[18] !== apex || $[19] !== faviconUrl || $[20] !== t12 || $[21] !== t13) {
      t14 = <NodeIconTile size="sm" id={t12} subject={apex} context={t13} logoUrl={faviconUrl} alt={apex} />;
      $[18] = apex;
      $[19] = faviconUrl;
      $[20] = t12;
      $[21] = t13;
      $[22] = t14;
    } else {
      t14 = $[22];
    }
    let t15;
    if ($[23] !== apex) {
      t15 = <span className="text-ds-text-primary truncate text-sm font-medium">{apex}</span>;
      $[23] = apex;
      $[24] = t15;
    } else {
      t15 = $[24];
    }
    const t16 = endpoints.length === 1 ? "" : "s";
    let t17;
    if ($[25] !== endpoints.length || $[26] !== t16) {
      t17 = <span className="text-ds-text-muted text-xs">{endpoints.length} endpoint{t16}</span>;
      $[25] = endpoints.length;
      $[26] = t16;
      $[27] = t17;
    } else {
      t17 = $[27];
    }
    let t18;
    if ($[28] !== t15 || $[29] !== t17) {
      t18 = <div className="flex min-w-0 flex-1 flex-col">{t15}{t17}</div>;
      $[28] = t15;
      $[29] = t17;
      $[30] = t18;
    } else {
      t18 = $[30];
    }
    if ($[31] !== t14 || $[32] !== t18) {
      t7 = <div className="flex items-center gap-3">{t14}{t18}</div>;
      $[31] = t14;
      $[32] = t18;
      $[33] = t7;
    } else {
      t7 = $[33];
    }
    let t19;
    if ($[34] !== visible) {
      t19 = visible.map(_temp3);
      $[34] = visible;
      $[35] = t19;
    } else {
      t19 = $[35];
    }
    let t20;
    if ($[36] !== overflow) {
      t20 = overflow > 0 && <Badge variant="outline">+{overflow}</Badge>;
      $[36] = overflow;
      $[37] = t20;
    } else {
      t20 = $[37];
    }
    if ($[38] !== t19 || $[39] !== t20) {
      t8 = <div className="flex flex-wrap items-center gap-1.5">{t19}{t20}</div>;
      $[38] = t19;
      $[39] = t20;
      $[40] = t8;
    } else {
      t8 = $[40];
    }
    t3 = "border-ds-neutral-200 text-ds-text-muted flex items-center justify-between border-t pt-3 text-xs";
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <span>Total calls</span>;
      $[41] = t4;
    } else {
      t4 = $[41];
    }
    t1 = "text-ds-text-primary font-medium tabular-nums";
    t2 = totalCalls.toLocaleString();
    $[0] = apex;
    $[1] = endpoints;
    $[2] = providerSlug;
    $[3] = T0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    T0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[42] !== t1 || $[43] !== t2) {
    t9 = <span className={t1}>{t2}</span>;
    $[42] = t1;
    $[43] = t2;
    $[44] = t9;
  } else {
    t9 = $[44];
  }
  let t10;
  if ($[45] !== t3 || $[46] !== t4 || $[47] !== t9) {
    t10 = <div className={t3}>{t4}{t9}</div>;
    $[45] = t3;
    $[46] = t4;
    $[47] = t9;
    $[48] = t10;
  } else {
    t10 = $[48];
  }
  let t11;
  if ($[49] !== T0 || $[50] !== t10 || $[51] !== t5 || $[52] !== t6 || $[53] !== t7 || $[54] !== t8) {
    t11 = <T0 href={t5} className={t6}>{t7}{t8}{t10}</T0>;
    $[49] = T0;
    $[50] = t10;
    $[51] = t5;
    $[52] = t6;
    $[53] = t7;
    $[54] = t8;
    $[55] = t11;
  } else {
    t11 = $[55];
  }
  return t11;
}
function _temp3(n) {
  return <NetworkChip key={n} network={n} />;
}
function _temp2(e_0) {
  return e_0.network;
}
function _temp(sum, e) {
  return sum + (e.totalCalls ?? 0);
}